import React from 'react'
import { Jobs } from '../jobs/Jobs'

export const ShortlistManager = () => {
  return (
    <Jobs />
  )
}
